(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const slideSelector = [
    '.slideshow-slide-einsatzbereiche',
    '.slideshow-slide-werkzeuge',
    '.slideshow-slide-fahrzeug-waehlen',
    '.slideshow-slide-aktion'
  ].join(',');
  const productSelector = [
    '.echtools-area-card',
    '.echtools-werkzeuge-product',
    '.fahrzeug-hero-product',
    '.et-aktion-product'
  ].join(',');

  const storeAttribute = (element, attribute) => {
    const key = `etOriginal${attribute.charAt(0).toUpperCase()}${attribute.slice(1)}`;
    if (key in element.dataset) return;
    element.dataset[key] = element.hasAttribute(attribute) ? element.getAttribute(attribute) : '';
  };

  const restoreAttribute = (element, attribute) => {
    const key = `etOriginal${attribute.charAt(0).toUpperCase()}${attribute.slice(1)}`;
    if (!(key in element.dataset)) return;
    const value = element.dataset[key];
    if (value === '') element.removeAttribute(attribute);
    else element.setAttribute(attribute, value);
    delete element.dataset[key];
  };

  const setStaticProducts = (root) => {
    root.querySelectorAll(productSelector).forEach((product) => {
      if (mobileQuery.matches) {
        ['href', 'target', 'rel', 'tabindex', 'role'].forEach((attribute) => storeAttribute(product, attribute));
        product.removeAttribute('href');
        product.removeAttribute('target');
        product.removeAttribute('rel');
        product.setAttribute('tabindex', '-1');
        product.setAttribute('role', 'group');
        product.setAttribute('aria-disabled', 'true');
      } else {
        ['href', 'target', 'rel', 'tabindex', 'role'].forEach((attribute) => restoreAttribute(product, attribute));
        product.removeAttribute('aria-disabled');
      }
    });
  };

  const fitMobileHero = (root, force = false) => {
    const slideshow = root.querySelector('.slideshow');
    if (!slideshow || !slideshow.querySelector(slideSelector)) return;

    setStaticProducts(root);
    if (!mobileQuery.matches) {
      slideshow.style.removeProperty('--et-mobile-hero-height');
      delete slideshow.dataset.etMobileViewportWidth;
      return;
    }

    const viewportWidth = Math.round(window.visualViewport?.width || window.innerWidth);
    const previousWidth = Number(slideshow.dataset.etMobileViewportWidth || 0);
    if (!force && previousWidth && Math.abs(viewportWidth - previousWidth) < 10) return;

    const viewportHeight = Math.round(window.visualViewport?.height || window.innerHeight);
    const documentTop = Math.max(0, Math.round(slideshow.getBoundingClientRect().top + window.scrollY));
    const availableHeight = Math.max(36 * parseFloat(getComputedStyle(document.documentElement).fontSize), viewportHeight - documentTop);
    slideshow.style.setProperty('--et-mobile-hero-height', `${Math.round(availableHeight)}px`);
    slideshow.dataset.etMobileViewportWidth = String(viewportWidth);
  };

  const init = () => {
    document.querySelectorAll('slideshow-component').forEach((root) => fitMobileHero(root, true));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('pageshow', init);
  window.addEventListener('resize', () => {
    document.querySelectorAll('slideshow-component').forEach((root) => fitMobileHero(root));
  }, { passive: true });
  window.addEventListener('orientationchange', () => window.setTimeout(init, 180), { passive: true });
  mobileQuery.addEventListener?.('change', init);
})();
